import * as actions from '../services'
import * as types from './mutations-types'

export const loadUserPermissions = (context, payload) => {
  return actions.getUserPermissions(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setUserPermissions, response.data.profile_permissions)
    }
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/components/shareds/authorized-link/vuex/actions.js